var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiFilterOutline1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 25.6783C19.4267 26.0658 19.2975 26.4792 19.0005 26.7504C18.881 26.8702 18.739 26.9652 18.5828 27.03C18.4265 27.0948 18.259 27.1282 18.0898 27.1282C17.9207 27.1282 17.7532 27.0948 17.5969 27.03C17.4406 26.9652 17.2987 26.8702 17.1792 26.7504L11.9996 21.5708C11.8588 21.4331 11.7518 21.2646 11.6868 21.0787C11.6218 20.8927 11.6007 20.6942 11.625 20.4988V13.8854L5.43796 5.9675C5.22821 5.69823 5.13356 5.35687 5.17471 5.01803C5.21585 4.67919 5.38944 4.37041 5.65755 4.15917C5.90296 3.97833 6.17421 3.875 6.45838 3.875H24.5417C24.8259 3.875 25.0971 3.97833 25.3425 4.15917C25.6107 4.37041 25.7842 4.67919 25.8254 5.01803C25.8665 5.35687 25.7719 5.69823 25.5621 5.9675L19.375 13.8854V25.6783ZM9.09338 6.45833L14.2084 12.9942V20.1242L16.7917 22.7075V12.9813L21.9067 6.45833H9.09338Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFilterOutline1);
export default __webpack_public_path__ + "static/media/mdi_filter-outline (1).54a5efbf980a5d11d663fd47f6fc52a9.svg";
export { ForwardRef as ReactComponent };